import { Breakpoint } from '@mui/system'

export const CONTAINER_MAX_WIDTH: Breakpoint = 'xl'

export const DEFAULT_LOCALE = 'en-US'

export const READINGS_FETCH_MORE_OFFSET = 32

export const BOOK_READINGS_FETCH_MORE_OFFSET = 7

export const ADMIN_FETCH_MORE_OFFSET = 7

export const READING_START_TIME_DELAY_MINUTES = 30

export const READING_START_TIME_INTERVAL_MINUTES = 15

export const CREATE_READING_UTC_START_HOUR = 11

export const CREATE_READING_UTC_END_HOUR = 1

export const CREATE_READING_LOCAL_START_HOUR_DANISH = 9

export const CREATE_READING_LOCAL_END_HOUR_DANISH = 19

export const READING_END_REMINDER_MINUTES = 5

export const READING_ABOUT_TO_START_MINUTES = 15

export const READING_DURATION = 30

export const READING_ELIGIBILITY_WINDOW_HOURS = 24

export const MAX_READERS = 6

export const MAX_READERS_DA = 6

export const QUOTE_CARDS_EVERY_N_ROW = 2

export const MIN_VIDEO_WIDTH = 160

export const VIDEO_TILE_GAP = 16

export const VIDEO_TILE_RATIO = '16/9'

export const SENDMAILSONPREVIEW = true

export const LIBRARYCARD_EXPIRATION_DAYS = 30

export const LIBRARYCARD_EXPIRATION_DAYS_DA = 30

export const EMAIL_VERIFICATION_MAX_AGE = 31 * 24 * 60 * 60 // 31 days

export const UNSUBSCRIBE_TOKEN_MAX_AGE = 365 * 24 * 60 * 60 // 1 year

export const EMAIL_BATCH_SIZE = 25 // Batch size for Hasura user insertions to avoid timeouts on legacy tier

export const MAX_NUMBER_OF_READINGS_A_WEEK = 5

export const READING_CANCEL_IF_BOOK_ABSENT_MINUTES = 10

export const READING_MINUTES_FROM_READING_ENDING = 10

export const READING_EVENT_STARTING_AT_MINUTES = 0

export const READING_EVENT_BOOK_ABSENT_CANCEL_AT_MINUTES = 10

export const READING_EVENT_ENDING_AT_MINUTES = 20

export const READING_EVENT_COMPLETED_AT_MINUTES = 30

export const BOOK_ABSENT_COMMENT = 'Book absent'

export const MAX_NUMBER_OF_RESERVATIONS = 3

export const GET_READINGS_INTERVAL_DAYS = 7
